<div id="content">
  <div class="page-title d-flex align-items-center justify-content-between flex-wrap mb-3">
    <h1>{{ page_title }}</h1>
    <div class="page-title-actions d-flex flex-wrap gap-2">
      <a mat-stroked-button routerLink="/employees/rrhh/job-description-templates">
        <mat-icon>description</mat-icon>
        Plantillas de descripción
      </a>
      <a mat-stroked-button routerLink="/employees/rrhh/exam-instances">
        <mat-icon>assignment</mat-icon>
        Exámenes
      </a>
      <button mat-flat-button color="accent" type="button" (click)="openCreateDialog()">
        <mat-icon>add</mat-icon>
        Nueva vacante
      </button>
    </div>
  </div>

  <div class="bisual-table">
    <form class="card paginator" [formGroup]="filterForm">
      <mat-paginator
        [length]="length"
        [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions"
        [pageIndex]="pageIndex"
        (page)="changePage($event)"
        style="margin-right: auto"
      ></mat-paginator>

      <mat-form-field class="bisual-paginator-select">
        <mat-label>Estado</mat-label>
        <mat-select formControlName="is_active">
          @for (option of is_active_filter_options; track option.label) {
            <mat-option [value]="option.value">{{ option.label }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <input matInput type="text" formControlName="search" placeholder="Buscar..." />
        <button matSuffix mat-icon-button aria-label="Buscar" type="button">
          <mat-icon>search</mat-icon>
        </button>
      </mat-form-field>
    </form>

    <div class="bisual-table-container">
      <table mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="title">
          <th mat-header-cell *matHeaderCellDef>Título</th>
          <td mat-cell *matCellDef="let element">
            <a [routerLink]="['/employees', 'rrhh', 'job-vacancies', element.id]">{{ element.title }}</a>
          </td>
        </ng-container>

        <ng-container matColumnDef="department_categories">
          <th mat-header-cell *matHeaderCellDef>Categorías</th>
          <td mat-cell *matCellDef="let element">
            <span [matTooltip]="element.department_categories_label.length > 50 ? element.department_categories_label : null">
              {{ element.department_categories_label }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="period">
          <th mat-header-cell *matHeaderCellDef>Vigencia</th>
          <td mat-cell *matCellDef="let element">{{ element.period_label }}</td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Estado</th>
          <td mat-cell *matCellDef="let element">{{ element.status_label }}</td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element" class="actions-cell">
            <div class="table-actions">
              <button mat-icon-button type="button" matTooltip="Editar" (click)="openEditDialog(element)">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button type="button" matTooltip="Eliminar" (click)="deleteJobVacancy(element)">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </div>
</div>
